.banner {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 1rem;
  background: color-mix(in srgb, var(--warn) 10%, var(--paper));
  border: 1px solid var(--warn);
  border-radius: var(--radius-sharp);
  color: var(--ink);
  font-family: var(--font-body);
  font-size: var(--text-min-body);
}

.item {
  margin: 0;
}
